/**
 * Con que se maneja este aparato.
 *
 * La pregunta no es "es tactil" sino "cual es el medio PRINCIPAL de apuntado",
 * y la diferencia es una maquina concreta: la all-in-one del mostrador es
 * tactil Y tiene raton, asi que `any-pointer: coarse` da verdadero ahi tambien.
 * `pointer` mira el principal. Es la misma trampa que explica CLAUDE.md §13 para
 * el boton de la camara, y la misma consulta que usa `useCameraScanAvailable`
 * del otro lado (`lib/scanner.ts`).
 *
 * SE PREGUNTA AL USAR, NO AL CARGAR EL MODULO, y por eso es un gancho y no una
 * constante: a un iPad le pueden poner un teclado a media sesion, y a un
 * escritorio le pueden quitar el raton. El oyente de `change` ademas repinta,
 * que es lo que hace que la pista del teclado aparezca sola.
 *
 * Decide dos cosas hoy, y ninguna es cosmetica:
 *
 *   - Si se dibuja la pista de una tecla (`KeyHint` en components/ui.tsx). En
 *     una pantalla que solo se toca, un "Enter" dibujado es ruido sobre una
 *     tecla que no existe.
 *   - Si un campo nace enfocado. En tactil eso abre el teclado del sistema y
 *     tapa media hoja (ver `TicketWhatsApp`).
 */

import { useEffect, useState } from 'react';

const FINE = '(pointer: fine)';

export function usePrecisePointer(): boolean {
  const [precise, setPrecise] = useState(() => window.matchMedia(FINE).matches);

  useEffect(() => {
    const query = window.matchMedia(FINE);
    const update = (): void => setPrecise(query.matches);
    update();
    query.addEventListener('change', update);
    return () => query.removeEventListener('change', update);
  }, []);

  return precise;
}

/**
 * Lo mismo, para quien no puede usar un gancho —dentro de un efecto, en una
 * rama que corre una sola vez—. Se lee en el momento, nunca se memoriza.
 */
export function precisePointer(): boolean {
  return window.matchMedia(FINE).matches;
}
